import { createSlice } from '@reduxjs/toolkit'

interface BurgerState {
	active: boolean
}

const initialState: BurgerState = {
	active: false,
}

const burgerSlice = createSlice({
	name: 'burger',
	initialState,
	reducers: {
		toggleMenu: (state) => {
			state.active = !state.active
		},

		closeMenu: (state) => {
			state.active = false
		},
	},
})

export const { toggleMenu, closeMenu } = burgerSlice.actions

export default burgerSlice.reducer
